/**
 * Startzonen.
 *
 * Die Startzone eines Sektors sind die ersten Reihen von seiner Außenkante aus
 * gesehen — bei der Regelvorgabe **zwei Reihen**, also Reihe A und B und damit
 * 15 Felder pro Sektor (`docs/GAME_RULES.md`, Abschnitt 2).
 *
 * Die Reihenzahl ist ein **Balancewert** und wird deshalb hereingegeben, nie hier
 * festgelegt: die Größe der Startzone verändert Eröffnung, Respawn-Druck und
 * Setup-Strategie. Der Default `2` lebt in der RuleConfig (`startZone.rows`,
 * `docs/RULE_CONFIG.md`), nicht in der Engine. Dass diese Funktion `rows` verlangt
 * statt einen Default anzunehmen, ist Absicht — ein stillschweigender Default wäre
 * genau die hartcodierte Balancezahl, die das Projekt verbietet.
 *
 * Die Referenzgrafik markiert drei Startreihen. Es gilt die Regel, nicht die Grafik
 * (`docs/OPEN_QUESTIONS.md` Nr. 11); der Unterschied ist in
 * `test/reference-graphic.test.ts` ausdrücklich festgehalten.
 */
import { hexDistance, hex } from './hex.js';
import { cellSector, sectorCells } from './sectors.js';
function assertRows(layout, rows) {
    if (!Number.isInteger(rows) || rows < 1) {
        throw new RangeError(`startZone.rows muss eine ganze Zahl ab 1 sein, war ${rows}`);
    }
    if (rows > layout.board.radius) {
        throw new RangeError(`startZone.rows ${rows} übersteigt die Sektortiefe ${layout.board.radius} bei Kantenlänge ${layout.board.sideLength}`);
    }
}
/**
 * Die Startfelder eines Sektors, von der Außenkante nach innen.
 *
 * Reihe A liegt auf der Distanz `radius`, jede weitere Reihe eine Distanz näher am
 * Zentrum.
 */
export function startZoneCells(layout, sector, options) {
    assertRows(layout, options.rows);
    const innermost = layout.board.radius - options.rows + 1;
    return sectorCells(layout, sector).filter((cell) => hexDistance(hex(0, 0), cell) >= innermost);
}
/** Gehört das Feld zur Startzone **dieses** Sektors? */
export function isStartZoneCell(layout, sector, cell, options) {
    assertRows(layout, options.rows);
    if (cellSector(layout, cell) !== sector)
        return false;
    const innermost = layout.board.radius - options.rows + 1;
    return hexDistance(hex(0, 0), cell) >= innermost;
}
//# sourceMappingURL=start-zone.js.map